import { create } from "zustand";
import client from "../api/client";

export const useDomainStore = create((set, get) => ({
  domains: [],
  currentDomain: null,
  isLoading: false,
  error: null,

  setCurrentDomain: (domain) => {
    if (domain) {
      localStorage.setItem("currentDomainId", domain.id);
    } else {
      localStorage.removeItem("currentDomainId");
    }
    set({ currentDomain: domain });
  },

  loadCurrentDomain: () => {
    const id = localStorage.getItem("currentDomainId");
    if (id) {
      const found = get().domains.find((d) => d.id === id);
      if (found) set({ currentDomain: found });
    }
  },

  fetchDomains: async () => {
    set({ isLoading: true, error: null });
    try {
      const { data } = await client.get("/api/domains");
      set({ domains: data.domains || [], isLoading: false });
      get().loadCurrentDomain();
      return data.domains;
    } catch (err) {
      set({ error: err.response?.data?.error || "Failed to load domains", isLoading: false });
      throw err;
    }
  },

  createDomain: async (payload) => {
    try {
      const { data } = await client.post("/api/domains", payload);
      set((state) => ({ domains: [data.domain, ...state.domains] }));
      return data.domain;
    } catch (err) {
      throw err.response?.data || err;
    }
  },

  deleteDomain: async (id) => {
    try {
      await client.delete(`/api/domains/${id}`);
      set((state) => ({
        domains: state.domains.filter((d) => d.id !== id),
        currentDomain: state.currentDomain?.id === id ? null : state.currentDomain,
      }));
    } catch (err) {
      throw err.response?.data || err;
    }
  },
}));
